export enum ECreateFarmStep {
  selectToken = 1,
  configReferralFarm = 2,
  depositRewards = 3,
}
